$(document).ready(function () {
    var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);

    const typeLabels = {
        0: "FIXED_LINE",
        1: "MOBILE",
        2: "FIXED_LINE_OR_MOBILE",
        3: "TOLL_FREE",
        4: "PREMIUM_RATE",
        5: "SHARED_COST",
        6: "VOIP",
        7: "PERSONAL_NUMBER",
        8: "PAGER",
        9: "UAN",
        10: "VOICEMAIL"
    };

    const errorMap = [
        oDict["phone_invalid_number"],
        oDict["phone_invalid_country_code"],
        oDict["phone_too_short"],
        oDict["phone_too_long"],
        oDict["phone_invalid_number"]
    ];

    // Pour chaque bloc téléphone
    document.querySelectorAll('.intl-tel-wrapper').forEach(wrapper => {
        const input = wrapper.querySelector(".intl-tel-input");
        const button = wrapper.querySelector(".btn-tel-input-validate");
        const errorMsg = wrapper.querySelector(".error-msg-tel-input");
        const validMsg = wrapper.querySelector("#valid-msg-tel-input");

        let phone_plugin_country = "us"; // fallback

        if (input.dataset.country && input.dataset.country.length > 0) {
            phone_plugin_country = input.dataset.country;
        }

        const iti = window.intlTelInput(input, {
            initialCountry: phone_plugin_country,
            strictMode: true,
            nationalMode: true,
            autoPlaceholder: "off",
            utilsScript: "/assets/250725215539/js/plugins/intl-tel-input/utils.js?1713364227752",
            geoIpLookup: callback => {
                fetch("https://ipapi.co/json")
                    .then(res => res.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback("us"));
            },
        });

        const reset = () => {
            input.classList.remove("error");
            errorMsg.innerHTML = "";
            errorMsg.classList.add("hide");
            validMsg.classList.add("hide");
        };

        const showError = (msg) => {
            input.classList.add("error");
            errorMsg.innerHTML = msg;
            errorMsg.classList.remove("hide");
        };

        const validatePhoneNumber = function (e) {
            let hasEvent = false;
            if (e && e.preventDefault) {
                hasEvent = true;
            }
            console.log('click validatePhoneNumber');

            reset();
            console.log('reset');
            if (!input.value.trim()) {
                // rien à faire
                console.log('click validatePhoneNumber - nothing');
            } else if (iti.isValidNumber()) {
                validMsg.classList.remove("hide");

                wrapper.querySelector('input[name="phone_national"]').value = iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL);
                wrapper.querySelector('input[name="phone_dial_code"]').value = iti.getSelectedCountryData().dialCode;
                wrapper.querySelector('input[name="phone_country_code"]').value = iti.getSelectedCountryData().iso2;
                wrapper.querySelector('input[name="phone_e164"]').value = iti.getNumber(intlTelInputUtils.numberFormat.E164);

                const numberType = iti.getNumberType();
                const readableType = typeLabels[numberType] || "UNKNOWN";
                wrapper.querySelector('input[name="phone_type"]').value = readableType;

                console.log('click validatePhoneNumber - valid', {
                    national: iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL),
                    dialCode: iti.getSelectedCountryData().dialCode,
                    countryCode: iti.getSelectedCountryData().iso2,
                    e164: iti.getNumber(intlTelInputUtils.numberFormat.E164),
                    type: readableType
                });

                return true;
            } else {

                console.log('click validatePhoneNumber - invalid', {
                    national: iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL),
                    dialCode: iti.getSelectedCountryData().dialCode,
                    countryCode: iti.getSelectedCountryData().iso2,
                    e164: iti.getNumber(intlTelInputUtils.numberFormat.E164),
                    type: typeLabels[iti.getNumberType()] || "UNKNOWN"
                });

                const errorCode = iti.getValidationError();
                const msg = errorMap[errorCode] || "Invalid number";
                showError(msg);
                if (hasEvent) e.preventDefault();

                return false;
            }
        };

        // Liaison des événements
        if(button){
            button.addEventListener('click', validatePhoneNumber);
        }
        input.addEventListener('input', validatePhoneNumber);
        input.addEventListener('change', reset);
        input.addEventListener('keyup', reset);

        // gestion du changement de pays spécifique à cet input
        wrapper.addEventListener('changePhoneCountry', function (e) {
            iti.setCountry(e.detail.countryCode);
        });
    });
});